<template>
  <div class="col-12 col-tab-1">

    <div class="row justify-content-center" v-if="showCompatibility == false">
      <div class="col-12">
        <h5 class="tab-title">Verificación por IMEI</h5>

        <p class="f-w-500 text-center">
          ¿Tienes duda si tu equipo es compatible con la red de Skycel?<br />
          ¡Sigue las siguientes instrucciones para saberlo!.
        </p>
      </div>

      <div class="col-12 text-center col-steps">
        <div class="row">
          <div class="col-md-4 col-step">
            <p>
              <i class="fad fa-mobile-alt icon-svg"></i>
              <!-- <img src="public/images/pages/compatibility/step-1.png"> -->
            </p>
            <h5>Paso 1</h5>
            <p>
              Ingresa a la marcación<br />en tu teléfono.
            </p>
          </div>

          <div class="col-md-4 col-step">
            <p>
              <i class="fad fa-hashtag icon-svg"></i>
              <!-- <img src="public/images/pages/compatibility/step-2.png"> -->
            </p>
            <h5>Paso 2</h5>
            <p>
              Digita <strong>*#06#</strong><br />
              para obtener tu IMEI.
            </p>
          </div>

          <div class="col-md-4 col-step">
            <p>
              <i class="fad fa-keyboard icon-svg"></i>
              <!-- <img src="public/images/pages/compatibility/step-3.png"> -->
            </p>
            <h5>Paso 3</h5>
            <p>
              Ingresa tu IMEI en el<br />
              formulario de abajo.
            </p>
          </div>
        </div>
      </div>

      <b-form class="row justify-content-center" @submit="onSubmit">
        <b-form-group class="col-md-6 col-lg-9 custom-f-group" label="Ingresa tu IMEI:">
          <b-form-input
            v-model="form.imei"
            type="number"
            required
            placeholder=""
          ></b-form-input>
        </b-form-group>

        <div class="col-10 text-center" v-if="!isProcessing">
          <b-button type="submit" class="btn-send btn-s2">Consultar</b-button>
        </div>
        <div class="col-10 text-center" v-else>
          <b-button disabled class="btn-send btn-s2">Consultando...</b-button>
        </div>
      </b-form>
    </div>

    <div class="row" v-else>
      <div class="col-12 col-imei-info mt-4">

		<div v-if="altanResponse.deviceFeatures.band28 == 'NO'">
			<error-checkmark-component />
			<h5 class="tab-title">El {{altanResponse.deviceFeatures.brand}} {{altanResponse.deviceFeatures.model}} no es compatible con nuestra red</h5>
		</div>

		<div  v-else-if="altanResponse.deviceFeatures.volteCapable == 'NO'">
			<success-checkmark2-component/>
			<h5 class="tab-title">El {{altanResponse.deviceFeatures.brand}} {{altanResponse.deviceFeatures.model}} es parcialmente compatible con la red de Skycel®.</h5>
			<p>
				Para la funcionlidad completa requiere <b>VozAPP</b>
			</p>
		</div>
		<div  v-else>
			<success-checkmark2-component/>
			<h5 class="tab-title">El {{altanResponse.deviceFeatures.brand}} {{altanResponse.deviceFeatures.model}} es compatible con la red de Skycel®.</h5>
		</div>

		<b-row class="mt-4 mb-4">
			<b-col>
				<h3 class="mb-4">IMEI</h3>
				<b-table :items="objectToArray(altanResponse.imei)" />
			</b-col>
			<b-col>
				<h3 class="mb-4">Características de hardware</h3>
				<b-table :items="objectToArray(altanResponse.deviceFeatures)" />
			</b-col>	
		</b-row>

		

		

        <p class="f-w-500">
          Verifica si otro equipo puede gozar de los beneficios que ofrece la red.
        </p>

        <p class="mt-3">
          <a class="link-orange f-w-600" @click="showCompatibility = false;"><i class="fas fa-mobile-android-alt"></i> Verificar nuevo dispositivo</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import mobiscroll from "@mobiscroll/javascript";
import errorCheckmarkComponent from "../shared/error-checkmark-component-1.vue";
import successCheckmark2Component from "../shared/success-checkmark-component-2.vue";
import { BootstrapVue, BTable } from 'bootstrap-vue';
import _ from "lodash";

export default {
	data() {
		return {
			showCompatibility: false,
			isProcessing: false,
			altanResponse: {

				imei: {
					imei: null,
					homologated: null,
					blocked: null,
					sub_category: null,
					soportaESIM: null,
				},

				deviceFeatures: {
					volteCapable: null,
					band28: null,
					model: null,
					brand: null,
				},

			},

			form: {
				imei: "",
			},
		};
	},

	methods: {
		objectToArray(obj) {
			let keyReLabel = (keyName) => {
				let renamers = {
					imei: "IMEI",
					homologated: "Homologado",
					blocked: "Bloqueado",
					sub_category: "Sub categoría",
					soportaESIM: "Soporta eSIM",
					volteCapable: "Soporta VolTE",
					band28: "Banda 28",
					model: "Modelo",
					brand: "Marca",
				}
				return renamers[keyName]
			};
			return _.map(obj, (Dato, Valor) => {
				Valor = keyReLabel(Valor)
				return { Valor, Dato };
			});
		},
		async onSubmit(event) {
			event.preventDefault();

			// IS PROCESSING
			this.isProcessing = true;

			// TRYING
			try {
				let response = await Axios.get(
					"consulta/imei/" + this.form.imei
				);

				// RESPONSE STATUS
				if (response.status) {
					this.form.imei = "";
					this.showCompatibility = true;
					this.altanResponse = response.data;
				}

				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if (response.msg) {
					mobiscroll.snackbar({
						display: "top",
						theme: "ios",
						message: response.msg,
						color: response.class,
						duration: 7000,
					});
				}
			} catch (e) {
				console.error(e);
			}

			// IS NOT
			this.isProcessing = false;
		},
	},

	components: {
		successCheckmark2Component,
		errorCheckmarkComponent,
		BootstrapVue, 
		BTable
	},
};
</script>
